import { CopyIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import {
	autoUpdate,
	flip,
	shift,
	useDismiss,
	useFloating,
	useFocus,
	useHover,
	useInteractions,
	useRole,
} from "@floating-ui/react";
import { type ReactNode, useState } from "react";
import { useSimpleToast } from "../hooks/toast.hooks";

const CopyOnClick = ({
	children,
	content,
}: {
	children: ReactNode;
	content: string;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const {
		refs,
		floatingStyles: style,
		context,
	} = useFloating({
		open: isOpen,
		placement: "bottom",
		onOpenChange: setIsOpen,
		middleware: [flip(), shift()],
		whileElementsMounted: autoUpdate,
	});
	const hover = useHover(context, { move: false });
	const toast = useSimpleToast();
	const focus = useFocus(context);
	const dismiss = useDismiss(context);
	const role = useRole(context, {
		role: "tooltip",
	});
	const { getReferenceProps, getFloatingProps } = useInteractions([
		hover,
		focus,
		dismiss,
		role,
	]);
	const handleOnClick = () => {
		navigator.clipboard.writeText(content);
		toast.info(
			"Commande",
			"L'id de la commande a été copié dans le presse papier.",
		);
	};
	return (
		<Box ref={refs.setReference} {...getReferenceProps} onClick={handleOnClick}>
			{children}
			{isOpen && (
				<Box
					ref={refs.setFloating}
					style={style}
					{...getFloatingProps()}
					bgColor="white"
					p={2}
					borderRadius="md"
					boxShadow="md"
					w="min(fit-content,30rem,90vw)"
					textAlign="center"
					zIndex={10000}
					color="brand.700"
				>
					<CopyIcon mr={2} />
					Copier l'id de commande
				</Box>
			)}
		</Box>
	);
};

export default CopyOnClick;
